import { Injectable } from '@angular/core';
import { UserLanguagePipe } from 'inova-front-core/helpers/pipes';

@Injectable({
  providedIn: 'root'
})
export class UserCustomizationService {

  constructor(
    private userLanguagePipe: UserLanguagePipe
  ) { }

  setPrimaryColor() {
    const mainColor = this.userLanguagePipe.transform("[[mainAppColor]]");
    if (!(mainColor.includes("["))) {
      let root = document.documentElement;
      root.style.setProperty('--primary_color', mainColor);
    }
  }

}
